<template>
  <div :class="clsx('partners-information-wrapper', { 'animations-disabled': !animationEnabled })" id="partners-information">
    <IntersectionObserver
      class="partners-information-intersector"
      :animation-enabled="animationEnabled"
      :once="true"
      once-class="partners-information-intersector--visible"
      :threshold="0.3"
    >
      <div class="partners-information__title-block">
        <h2 class="partners-information__title-block__title" v-html="getTitleBlock('promo', 'partners-information', 'title')"></h2>
        <p class="partners-information__title-block__description" v-html="getTitleBlock('promo', 'partners-information', 'description')"></p>
      </div>
      <div class="partners-information__info-block">
        <div class="partners-information__info-block__card partners-information__info-block__card--insurance-companies">
          <div class="partners-information__info-block__text-block">
            <h4 class="partners-information__info-block__title">Про страхові компанії</h4>
          </div>
          <VioletFancyButton class="partners-information__info-block__button" :route="{ name: 'insurance-companies' }">
            <span class="partners-information__info-block__button-text">Переглянути</span>
            <span class="partners-information__info-block__button-icon"><RightArrow /></span>
          </VioletFancyButton>
        </div>
        <div class="partners-information__info-block__card partners-information__info-block__card--insurance-intermediary">
          <div class="partners-information__info-block__text-block">
            <h4 class="partners-information__info-block__title">Про страхового посередника</h4>
          </div>
          <VioletFancyButton class="partners-information__info-block__button" :route="{ name: 'insurance-intermediary' }">
            <span class="partners-information__info-block__button-text">Переглянути</span>
            <span class="partners-information__info-block__button-icon"><RightArrow /></span>
          </VioletFancyButton>
        </div>
      </div>
      <div class="partners-information__background-blocks">
        <BackgroundGradientOrange class="partners-information__background-gradient-orange" />
      </div>
    </IntersectionObserver>
  </div>
</template>

<script>
import clsx from 'clsx';
import BackgroundGradientOrange from './background-gradient-orange';
import { textBlock } from '@/entities/text-block';
import { VioletFancyButton } from '@/shared/ui/form';
import { RightArrow } from '@/shared/ui/icons';
import { IntersectionObserver } from '@/shared/ui/intersection-observer';

export default {
  props: {
    animationEnabled: {
      type: Boolean,
      default: true,
    },
  },
  mixins: [ textBlock ],
  components: { VioletFancyButton, RightArrow, BackgroundGradientOrange, IntersectionObserver },
  methods: { clsx },
};
</script>

<style lang="scss" scoped>
.partners-information-intersector {
  position: relative;
  background-color: #FCFDFF;
  padding-top: 63px;
  opacity: 1;

  @media (max-width: 1050px) {
    padding-top: 50px;
  }

  @media (max-width: 800px) {
    padding-top: 40px;
  }

  @media (max-width: 600px) {
    padding-top: 30px;
  }
}

.partners-information__title-block {
  position: relative;
  margin-bottom: 45px;
  z-index: 1;

  @media (max-width: 1050px) {
    padding: 0 16px;
  }

  &__title {
    font-family: "IBM Plex Sans", sans-serif;
    font-size: 72px;
    font-weight: 500;
    color: #313437;
    text-align: center;
    margin-bottom: 16px;
    transform: translateY(100%);
    opacity: 0;
    animation: slideup-text-animation 1s linear forwards;
    animation-play-state: paused;

    @media (max-width: 1050px) {
      font-size: 64px;
    }

    @media (max-width: 800px) {
      font-size: 58px;
    }

    @media (max-width: 600px) {
      font-size: 50px;
    }
  }

  &__description {
    font-family: 'Inter', sans-serif;
    font-size: 18px;
    font-weight: 400;
    color: #494E53;
    text-align: center;
    transform: translateY(100%);
    opacity: 0;
    animation: slideup-text-animation 0.5s linear forwards;
    animation-delay: 1s;
    animation-play-state: paused;
  }
}

.partners-information__info-block {
  display: flex;
  justify-content: center;
  padding-bottom: 95px;
  overflow: hidden;
  position: relative;
  z-index: 2;

  @media (max-width: 1200px) {
    padding: 0 16px 64px;
  }

  @media (max-width: 800px) {
    flex-direction: column;
  }

  &__card {
    display: flex;
    align-items: center;
    background-color: rgba(255, 255, 255, 0.5);
    padding: 24px;
    border-radius: 32px;
    backdrop-filter: blur(24px);
    box-shadow: 0 14px 32px 0 #9199AE1C;

    @media (max-width: 800px) {
      margin-bottom: 32px;
    }

    @media (max-width: 600px) {
      padding: 24px 12px 24px 24px;
    }

    &--insurance-companies {
      margin-right: 32px;
      transform: translateX(-200%);
      animation: insurance-companies-animation 0.5s linear forwards;
      animation-delay: 1.5s;
      animation-play-state: paused;

      @media (max-width: 800px) {
        margin-right: 0;
      }
    }

    &--insurance-intermediary {
      transform: translateX(200%);
      animation: insurance-intermediary-animation 0.5s linear forwards;
      animation-delay: 1.5s;
      animation-play-state: paused;
    }
  }

  &__text-block {
    margin-right: 24px;

    @media (max-width: 1050px) {
      margin-right: auto;
    }
  }

  &__title {
    font-family: "IBM Plex Sans", sans-serif;
    font-size: 22px;
    font-weight: 500;
    color: #494E53;
    padding-bottom: 4px;
  }

  &__button {
    @media (max-width: 600px), (min-width: 800px) and (max-width: 1050px) {
      padding: 10px;
      margin-left: 8px;
    }

    @media (max-width: 600px) {
      padding: 10px 0 10px 10px;
    }
  }

  &__button-text {
    @media (max-width: 600px), (min-width: 800px) and (max-width: 1050px) {
      display: none;
    }
  }

  &__button-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 30px;
    height: 30px;
    background-color: #FFFFFF;
    border-radius: 50%;
    margin-left: 10px;

    @media (max-width: 600px), (min-width: 800px) and (max-width: 1050px) {
      margin-left: 0;
    }
  }
}

.partners-information__background-gradient-orange {
  position: absolute;
  top: 230px;
  right: 0;
  width: 745px;
  height: 745px;
  overflow: hidden;
  z-index: 1;
}

::v-deep .violet-fancy-button {
  @media (max-width: 600px), (min-width: 800px) and (max-width: 1050px) {
    padding: 8px !important;
  }
}

.partners-information-intersector {
  &--visible {
    .partners-information__title-block__title,
    .partners-information__title-block__description,
    .partners-information__info-block__card--insurance-companies,
    .partners-information__info-block__card--insurance-intermediary {
      animation-play-state: running;
    }
  }
}

.animations-disabled,
.animations-disabled * {
  animation: none !important;
  animation-duration: 0s !important;
  animation-delay: 0s !important;
  transition: none !important;
}

.animations-disabled {
  .partners-information__title-block {
    &__title, &__description {
      clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
      transform: translateY(0);
      opacity: 1;
    }
  }

  .partners-information__info-block {
    &__card--insurance-companies, &__card--insurance-intermediary {
      transform: translateX(0);
    }
  }
}

@keyframes slideup-text-animation {
  0% {
    opacity: 1;
    clip-path: polygon(0 0, 100% 0, 100% 0%, 0 0%);
    transform: translateY(100%);
  }
  20% {
    opacity: 1;
    clip-path: polygon(0 0, 100% 0, 100% 20%, 0 20%);
    transform: translateY(80%);
  }
  40% {
    opacity: 1;
    clip-path: polygon(0 0, 100% 0, 100% 40%, 0 40%);
    transform: translateY(60%);
  }
  60% {
    opacity: 1;
    clip-path: polygon(0 0, 100% 0, 100% 60%, 0 60%);
    transform: translateY(40%);
  }
  80% {
    opacity: 1;
    clip-path: polygon(0 0, 100% 0, 100% 80%, 0 80%);
    transform: translateY(20%);
  }
  100% {
    opacity: 1;
    clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
    transform: translateY(0);
  }
}

@keyframes insurance-companies-animation {
  from {
    transform: translateX(-200%);
  }
  to {
    transform: translateX(0);
  }
}

@keyframes insurance-intermediary-animation {
  from {
    transform: translateX(200%);
  }
  to {
    transform: translateX(0);
  }
}
</style>
